import React from 'react';
import { TextField, TextFieldProps, IconButton, InputAdornment } from '@mui/material';
import { Search, Close } from '@mui/icons-material';

export interface SearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    minWidth?: number | string;
    maxWidth?: number | string;
    fullWidth?: boolean;
    size?: TextFieldProps['size'];
    disabled?: boolean;
}

export const SearchField: React.FC<SearchFieldProps> = ({
    value,
    onChange,
    placeholder = 'Search...',
    minWidth = 250,
    maxWidth = 400,
    fullWidth = false,
    size = 'small',
    disabled = false,
}) => {
    const handleClear = () => {
        onChange('');
    };

    return (
        <TextField
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            size={size}
            fullWidth={fullWidth}
            disabled={disabled}
            sx={{
                minWidth,
                maxWidth,
                '& .MuiInputBase-root': {
                    paddingLeft: 1,
                    paddingRight: 0,
                },
                '& .MuiInputBase-input': {
                    paddingLeft: 1,
                },
            }}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start" sx={{ mr: 0 }}>
                            <Search sx={{ color: 'text.secondary' }} />
                        </InputAdornment>
                    ),
                    endAdornment: value ? (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={handleClear}
                                edge="end"
                                sx={{ mr: 0 }}
                                aria-label="Clear search"
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                },
            }}
        />
    );
};
